/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Price } from '@wit/vtv-x-foundation-lib';

export default class PricesUtils {
  static formatPrice(price: Price): string {
    const browserDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
    const priceLabel = new Intl.NumberFormat(browserDefaultLocale, {
      style: 'currency',
      currency: price.currency,
    }).format(price.amount);
    return priceLabel;
  }
}
